import { gql } from '@apollo/client/core';

export const deleteLocation = gql`
  mutation deleteLocation($id: ID!) {
    deleteLocation(id: $id) {
      value
    }
  }
`;
